import { render, staticRenderFns } from "./liveListComponent.vue?vue&type=template&id=061cdbe9&"
import script from "./liveListComponent.vue?vue&type=script&lang=ts&"
export * from "./liveListComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports